export const formatEstimateHours = (totalHoursRaw: number | string) => {
    const totalHours = parseFloat(totalHoursRaw as string);
    if (isNaN(totalHours)) return "";

    const days = Math.floor(totalHours / 8);
    const hours = (totalHours % 8).toFixed(1).replace(/\.0$/, "");

    if (days > 0) {
        return `${days} ngày${hours !== "0" ? ` ${hours} giờ` : ""}`;
    } else {
        return `${hours} giờ`;
    }
};